"use client"

import React from 'react';
import {useAppStore} from "@/store/AppStore";
import {TreeItem} from "@mui/x-tree-view/TreeItem";
import {CircularProgress} from "@mui/material";
import useSpiritualityData from "@/utils/hooks/useSpiritualityData";
import {Prayer} from "@/types/Prayers";

export default function SpiritualityItems() {

  const user = useAppStore((state) => state.user);
  const data = useSpiritualityData(user?.access_token)

  const items = data?.items

  if (!user) return null
  if (!data) return <CircularProgress/>

  return (
    <>
      {items && items.map((itm: Prayer, key: number) => {
        return <TreeItem key={key} label={itm.name} itemId={`spirituality-${itm.id}`}/>
      })
      }
    </>
  )
}
